var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icontext"},[(_vm.icon)?_c('img',{staticClass:"icon",attrs:{"src":_vm.icon || '',"alt":_vm.name+' icon'}}):_c('div',{staticClass:"icon capital"},[_vm._v(_vm._s(_vm.name[0]))]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }